export enum AcnFormStep {
  CONSENT = "ACN_CONSENT",
  FLOW_SELECT = "ACN_FLOW_SELECT",
  COMPANY_NAME = "ACN_COMPANY_NAME",
  DIRECTOR = "ACN_DIRECTOR",
  DIRECTOR_SHARE = "ACN_DIRECTOR_SHARE",
  COMPANY = "ACN_COMPANY",
  ABN = "ACN_ABN",
  IDENTITY = "ACN_IDENTITY",
  BASKET = "ACN_BASKET",
  CONFIRM = "ACN_CONFIRM",
  CHARGE = "ACN_CHARGE",
  COMPLETE = "ACN_COMPLETE",
}

export const FORM_STEP_TO_PATH: Record<AcnFormStep, string> = {
  [AcnFormStep.CONSENT]: "consent",
  [AcnFormStep.FLOW_SELECT]: "flow-select",
  [AcnFormStep.COMPANY_NAME]: "company-name",
  [AcnFormStep.DIRECTOR]: "director",
  [AcnFormStep.DIRECTOR_SHARE]: "director-share",
  [AcnFormStep.COMPANY]: "company",
  [AcnFormStep.ABN]: "abn-acn",
  [AcnFormStep.IDENTITY]: "identity",
  [AcnFormStep.BASKET]: "card-details",
  [AcnFormStep.CONFIRM]: "confirm",
  [AcnFormStep.CHARGE]: "charge",
  [AcnFormStep.COMPLETE]: "complete",
};
